import styled from "styled-components";

const CardQuestion = styled.div`
  color: #315c89;
  width: 63%;
  font-weight: 700;
  padding: 10px 5px 0px 10px;
  /*   font-size: 30px;
  padding: 15px 5px 0px 15px; */
  @media screen and (max-width: 425px) {
    padding: 10px 5px 0px 10px;
    font-size: 16px;
  }
`;
const CardAuthor = styled.div`
  color: #315c89;
  font-weight: 700;
  font-size: 12px;
  @media screen and (max-width: 425px) {
    font-size: 11px;
  }
`;
const CardTitle = styled.div`
  color: #315c89;
  font-weight: 400;
  /*  font-size: 14px; */
  font-size: 8px;
  margin-bottom: 5px;
  @media screen and (max-width: 425px) {
    font-size: 8px;
  }
`;
const CornerImage = styled.img`
  position: absolute;
  bottom: 0;
  right: 0;
  width: 37%;
  max-height: 100%;
`;
const HoverCornerImage = styled.img`
  display: none;
  position: absolute;
  bottom: 0;
  right: 0;
  width: 37%;
  max-height: 100%;
`;
const Card = styled.div`
  background: #fff;
  position: relative;
  width: 300px;
  height: 150px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin: 10px;
  transition: 0.5s all ease-in-out;
  @media screen and (max-width: 425px) {
    width: 300px;
    height: 150px;
  }
  &:hover {
    background: #315c89;
    cursor: pointer;
    transform: scale(1.1);
  }

  &:hover ${CardQuestion}, :hover ${CardTitle},:hover ${CardAuthor} {
    color: #fff;
  }
  &:hover ${CornerImage} {
    display: none;
  }
  &:hover ${HoverCornerImage} {
    display: block;
  }
`;
const Flex = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction || ""};
  justify-content: ${(props) => props.justify || ""};
  align-items: ${(props) => props.align || ""};
`;
const Color = styled.div`
  background: ${(props) => props.background || "red"};
  height: 3px;
  width: 20px;
  margin-right: 5px;
  @media screen and (max-width: 425px) {
    height: 3px;
    width: 20px;
  }
`;
function CardItem({ card, url, handleClick, ...props }) {
  return (
    <Card onClick={() => handleClick(card)}>
      <CardQuestion>{card.question}</CardQuestion>
      <Flex direction="row" align="center">
        {card.author_name && <Color background={card.color} />}
        <Flex direction="column">
          <CardAuthor>{card.author_name}</CardAuthor>
          <CardTitle>{card.author_title}</CardTitle>
        </Flex>
      </Flex>
      <CornerImage src={card.corner_image_url} />
      {card.hover_image && <HoverCornerImage src={card.hover_image_url} />}
      {!card.hover_image && <HoverCornerImage src={card.corner_image_url} />}
    </Card>
  );
}
export default CardItem;
